import { Component, OnInit, Input } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { BillyCurrencies } from 'src/app/@interfaces/Billy/billy.interface';
import { BillyService } from 'src/app/@pages/billyService/billy.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-select-currency',
  templateUrl: './select-currency.component.html',
  styleUrls: ['./select-currency.component.css'],
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatButtonModule,
    TranslatePipe,
  ],
})
export class SelectCurrencyComponent implements OnInit {
  @Input() currency: boolean = false;
  currencyList = {} as BillyCurrencies;
  currencyForm: UntypedFormGroup = this.fb.group({
    currency: [''],
  });
  unsubscribe$ = new Subject<void>();
  constructor(
    private billy: BillyService,
    private fb: UntypedFormBuilder,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.billy
      .getCurrencies()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        this.currencyList = result;
      });
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
